import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const InstagramApp = () => {

  const history = useNavigate();

  useEffect(() => {
    const redirectTimeout = setTimeout(() => {
      window.location.href = 'https://www.instagram.com/thelunaticproject/';
    }, 0);

    return () => clearTimeout(redirectTimeout);
  }, [history]);

  return (<></>);
}
